import { render, staticRenderFns } from "./advantages.vue?vue&type=template&id=6c28dd80&"
import script from "./advantages.vue?vue&type=script&lang=js&"
export * from "./advantages.vue?vue&type=script&lang=js&"
import style0 from "./advantages.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/funday/funday/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6c28dd80')) {
      api.createRecord('6c28dd80', component.options)
    } else {
      api.reload('6c28dd80', component.options)
    }
    module.hot.accept("./advantages.vue?vue&type=template&id=6c28dd80&", function () {
      api.rerender('6c28dd80', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "frontend/src/components/advantages/advantages.vue"
export default component.exports